/** DO NOT MODIFY THIS FILE. COMPILED AUTOMATICALLY FROM src/portal_ui/fm/* **/
export const fm_msgs = [
{
	"event_type" : "fan.drive",
	"info" : {
		"en" : "The fan motor in ${fru} is degraded: it needs to be cleaned or is failing."
	},
	"impact" : {
		"en" : "The other system fans will compensate but you may notice additional fan noise."
	},
	"action" : {
		"en" : "Contact iodyne Support for further assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/fan.drive",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "fan.spin",
	"info" : {
		"en" : "Fan ${fru} failed to spin up: it needs to be cleaned or is obstructed."
	},
	"impact" : {
		"en" : "The other system fans will compensate but you may notice additional fan noise."
	},
	"action" : {
		"en" : "Contact iodyne Support for further assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/fan.spin",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "fan.stall",
	"info" : {
		"en" : "The fan motor in ${fru} has stalled: it needs to be cleaned or is obstructed."
	},
	"impact" : {
		"en" : "The other system fans will compensate but you may notice additional fan noise."
	},
	"action" : {
		"en" : "Contact iodyne Support for further assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/fan.stall",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "fan.wdog",
	"info" : {
		"en" : "The fan controller watchdog has detected fan controller inactivity."
	},
	"impact" : {
		"en" : "The fan controller will be automatically restarted to recover."
	},
	"action" : {
		"en" : "Contact iodyne Support for further assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/fan.wdog",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
    "event_type" : "host.bad_cabling",
    "info" : {
        "en" : "Multipath cabling is incorrect."
    },
    "impact" : {
        "en" : "Multipathing is not enabled by the current configuration."
    },
    "action" : {
        "en" : "Verify that each cable is connected to a separate Pro Data port pair. Contact iodyne Support if you have questions."
    },
    "urls": [
        {
            "url" : "https://fm.iodyne.com/msg/host.bad_cabling",
            "content_type" : "application/vnd.iodyne.kb"
        }
    ]
}
,
{
	"event_type" : "host.mac_driver",
	"info" : {
		"en" : "The system extension version is not correct."
	},
	"impact" : {
		"en" : "The loaded system extension version does not match the installed system extension version."
	},
	"action" : {
		"en" : "If you recently updated your iodyne software, please open Privacy & Security System Settings to approve the iodyne system extension. Contact iodyne Support for assistance."
	},
	"urls": [
		{
		    "url" : "https://fm.iodyne.com/msg/host.mac_driver",
		    "content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "host.mac_driver_legacy",
	"info" : {
		"en" : "The system extension version is not correct."
	},
	"impact" : {
		"en" : "The loaded system extension version does not match the installed system extension version."
	},
	"action" : {
		"en" : "If you recently updated your iodyne software, please open Security & Privacy System Preferences to approve the iodyne system extension. Contact iodyne Support for assistance."
	},
	"urls": [
		{
		    "url" : "https://fm.iodyne.com/msg/host.mac_driver",
		    "content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "host.port_init",
	"info" : {
		"en" : "Thunderbolt connection failed."
	},
	"impact" : {
		"en" : "A Thunderbolt connection is unusable."
	},
	"action" : {
		"en" : "Unplug each cable and reconnect to retry, or use a different cable. Contact iodyne Support if the issue persists."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/host.port_init",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
    "event_type" : "host.port_tbt",
    "info" : {
        "en" : "Multipath cabling is suboptimal."
    },
    "impact" : {
        "en" : "Peak performance is limited because the computer's Thunderbolt bus is being shared."
    },
    "action" : {
        "en" : "Verify that each cable is connected to only one Thunderbolt bus for maximum performance. Contact iodyne Support for assistance."
    },
    "urls": [
        {
            "url" : "https://fm.iodyne.com/msg/host.port_tbt",
            "content_type" : "application/vnd.iodyne.kb"
        }
    ]
}
,
{
    "event_type" : "host.port_training",
    "info" : {
        "en" : "Thunderbolt connection is not at full speed."
    },
    "impact" : {
        "en" : "Performance will be degraded until a full-speed connection can be established."
    },
    "action" : {
        "en" : "Unplug the Thunderbolt cable and reconnect to retry, or use a new Thunderbolt cable; this cable may be degraded. Contact iodyne Support if the issue persists."
    },
    "urls": [
        {
            "url" : "https://fm.iodyne.com/msg/host.port_training",
            "content_type" : "application/vnd.iodyne.kb"
        }
    ]
}
,
{
    "event_type" : "host.register_device",
    "info" : {
        "en" : "The device is not registered."
    },
    "impact" : {
        "en" : "Registering your device to an iodyne Cloud account activates your extended warranty."
    },
    "action" : {
        "en" : "Register your device, or contact iodyne Support for assistance."
    },
    "urls": [
        {
            "url" : "https://iodyne.com/msg/host.register_device",
            "content_type" : "application/vnd.iodyne.kb"
        }
    ]
}
,
{
	"event_type" : "iod.fault",
	"info" : {
		"en" : "Device firmware has restarted after an internal error."
	},
	"impact" : {
		"en" : "Containers will unmount from your computer, and remount once firmware restarts.  RAID is automatically protecting your data, and all data will be available once firmware restart is complete."
	},
	"action" : {
		"en" : "Contact iodyne Support for further assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/iod.fault",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "iod.udev",
	"info" : {
		"en" : "Device firmware detected a hardware error condition during an internal data transfer."
	},
	"impact" : {
		"en" : "The device will reset or attempt firmware recovery.  RAID is automatically protecting your data, and all data will be available once recovery is complete."
	},
	"action" : {
		"en" : "If you just hot-plugged or disturbed a cable, restore the cable connection, or use the Device Eject button for safe unplug.  Contact iodyne Support for further assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/iod.udev",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "ns.faulty",
	"info" : {
		"en" : "Container is unavailable as a result of an underlying fault in the system."
	},
	"impact" : {
		"en" : "The data from this container will not be available until this fault is repaired."
	},
	"action" : {
		"en" : "Check the Status tab for more information on SSDs and other detected faults. Contact iodyne Support for further assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/ns.faulty",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "ns.unseal",
	"info" : {
		"en" : "The Secure Enclave failed to unseal a container."
	},
	"impact" : {
		"en" : "The data from this container will not be available until this fault is repaired."
	},
	"action" : {
		"en" : "Contact iodyne Support for further assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/ns.unseal",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "pci.link_down",
	"info" : {
		"en" : "An internal PCI Express link is down."
	},
	"impact" : {
		"en" : "The internal link will be automatically reset to attempt recovery.  RAID is automatically protecting your data, and adapting parity automatically."
	},
	"action" : {
		"en" : "Contact iodyne Support for assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/pci.link_down",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "pm.overtemp",
	"info" : {
		"en" : "The device has exceeded its supported temperature limit."
	},
	"impact" : {
		"en" : "Your data is protected, but the device may reset to protect itself and cool down if the temperature is not reduced."
	},
	"action" : {
		"en" : "Inspect your device to be sure that you do not have the vents blocked or obstructed to maintain proper air flow.  Move your device away from any external heated air or hot objects."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/pm.overtemp",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "pool.dsopen",
	"info" : {
		"en" : "The device storage pool failed to initialize a container because its metadata is unreadable."
	},
	"impact" : {
		"en" : "The affected container will not be available until this fault is repaired."
	},
	"action" : {
		"en" : "Verify that SSDs have not been physically removed from the device.  Use data from a backup copy if available.  Contact iodyne Support for assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/pool.dsopen",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "pool.empty",
	"info" : {
		"en" : "The device storage pool could not be opened because no SSD modules were found."
	},
	"impact" : {
		"en" : "The storage pool cannot be initialized until SSD modules are present."
	},
	"action" : {
		"en" : "If you removed SSD modules, power off your device and replace them.  Contact iodyne Support for assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/pool.empty",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "pool.faulty",
	"info" : {
		"en" : "The device storage pool is faulted and needs repair."
	},
	"impact" : {
		"en" : "The device firmware will attempt a reset in order to reopen and restore access to the storage pool."
	},
	"action" : {
		"en" : "Wait up to 2min for the reset to complete.  Check the Status tab and device LED status after the reset.  Contact iodyne Support for assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/pool.faulty",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "pool.resume",
	"info" : {
		"en" : "The device storage pool could not be resumed because multiple SSD modules were not responding."
	},
	"impact" : {
		"en" : "The device firmware will attempt a reset of affected components in order to reopen and restore access to the storage pool."
	},
	"action" : {
		"en" : "Wait up to 2min for the reset to complete.  Check the Status tab and device LED status after the reset.  Contact iodyne Support for assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/pool.resume",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "pool.ro",
	"info" : {
		"en" : "The device storage pool will be opened read-only because multiple SSD modules were not responding."
	},
	"impact" : {
		"en" : "Some containers may not be accessible. All accessible containers will be read-only until repairs are complete."
	},
	"action" : {
		"en" : "Check the Status tab for SSDs in need of repair. Contact iodyne Support for assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/pool.ro",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "ssd.eol",
	"info" : {
		"en" : "SSD module ${fru} has reached its end-of-life."
	},
	"impact" : {
		"en" : "RAID is automatically protecting your data, and no longer writing to this SSD."
	},
	"action" : {
		"en" : "Install a replacement SSD in slot ${fru}."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/ssd.eol",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "ssd.format",
	"info" : {
		"en" : "An SSD module could not be formatted."
	},
	"impact" : {
		"en" : "RAID is automatically protecting your data, and adapting parity automatically."
	},
	"action" : {
		"en" : "If you just replaced the SSD module, confirm that you used a valid spare device. Contact iodyne Support for assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/ssd.format",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "ssd.media",
	"info" : {
		"en" : "SSD module ${fru} has reached its end-of-life or has an unexpected media failure."
	},
	"impact" : {
		"en" : "RAID is automatically protecting your data, and no longer writing to this SSD."
	},
	"action" : {
		"en" : "Install a replacement SSD in slot ${fru}."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/ssd.media",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "ssd.minsize",
	"info" : {
		"en" : "SSD module ${fru} is too small to be used."
	},
	"impact" : {
		"en" : "The SSD module will not be used. RAID is automatically protecting your data, and adapting parity automatically."
	},
	"action" : {
		"en" : "Contact iodyne Support for assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/ssd.minsize",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "ssd.missing",
	"info" : {
		"en" : "An SSD module is missing."
	},
	"impact" : {
		"en" : "RAID is automatically protecting your data, and adapting parity automatically."
	},
	"action" : {
		"en" : "If you removed the SSD module, power off your device and replace it.  Contact iodyne Support for assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/ssd.missing",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "ssd.orphan",
	"info" : {
		"en" : "SSD module ${fru} is labeled from a different storage pool."
	},
	"impact" : {
		"en" : "The orphaned SSD will not be used.  RAID is automatically protecting your data, and adapting parity automatically."
	},
	"action" : {
		"en" : "Contact iodyne Support for assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/ssd.orphan",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "ssd.resume",
	"info" : {
		"en" : "SSD module ${fru} did not wake from power-managed sleep."
	},
	"impact" : {
		"en" : "The SSD will be automatically reset.  RAID is automatically protecting your data, and adapting parity automatically."
	},
	"action" : {
		"en" : "Contact iodyne Support for assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/ssd.resume",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "ssd.ro",
	"info" : {
		"en" : "SSD module ${fru} has entered read-only mode due to an internal media failure."
	},
	"impact" : {
		"en" : "RAID is automatically protecting your data, and no longer writing to this SSD."
	},
	"action" : {
		"en" : "Install a replacement SSD in slot ${fru}."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/ssd.ro",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "ssd.spare",
	"info" : {
		"en" : "SSD module ${fru} has exhausted its internal spare defect management space."
	},
	"impact" : {
		"en" : "RAID is automatically protecting your data, but this SSD may fail soon."
	},
	"action" : {
		"en" : "Install a replacement SSD in slot ${fru} at your next available downtime."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/ssd.spare",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "ssd.temp",
	"info" : {
		"en" : "SSD module ${fru} is exceeding temperature limits."
	},
	"impact" : {
		"en" : "RAID is automatically protecting your data."
	},
	"action" : {
		"en" : "Inspect your device to be sure that you do not have the vents blocked or obstructed to maintain proper air flow.  Move your device away from any external heated air or hot objects."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/ssd.temp",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "ssd.vmbd",
	"info" : {
		"en" : "SSD module ${fru} write cache power-loss backup device has failed."
	},
	"impact" : {
		"en" : "RAID is automatically protecting your data, and no longer writing to this SSD."
	},
	"action" : {
		"en" : "Install a replacement SSD in slot ${fru}."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/ssd.vmbd",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "ssd.zombie",
	"info" : {
		"en" : "An SSD module did not initialize."
	},
	"impact" : {
		"en" : "RAID is automatically protecting your data, and adapting parity automatically."
	},
	"action" : {
		"en" : "If you just replaced the SSD module, power off your device and make sure it is properly connected.  Contact iodyne Support for assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/ssd.zombie",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "tpm.nsids",
	"info" : {
		"en" : "The Secure Enclave failed to initialize properly during device startup."
	},
	"impact" : {
		"en" : "The storage pool cannot be initialized until the Secure Enclave is available."
	},
	"action" : {
		"en" : "Contact iodyne Support for further assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/tpm.nsids",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
{
	"event_type" : "tpm.prune",
	"info" : {
		"en" : "The Secure Enclave failed to initialize properly during device startup."
	},
	"impact" : {
		"en" : "The storage pool cannot be initialized until the Secure Enclave is available."
	},
	"action" : {
		"en" : "Contact iodyne Support for further assistance."
	},
	"urls": [
		{
			"url" : "https://fm.iodyne.com/msg/tpm.prune",
			"content_type" : "application/vnd.iodyne.kb"
		}
	]
}
,
]
